import React, { useContext } from 'react'
import { Search, List, Bookmarks } from '@material-ui/icons'
// import { useHistory } from 'react-router-dom'
import searchContext from '../../FiltersComponent/context/context'
import { getUserSFId } from '../../Utility/Utility'

export default () => {

    const { selectedMenu, setSelectedMenu } = useContext(searchContext)

    const modifyPath = newPath => {

        setSelectedMenu(newPath)

        let queryParam = `userId=${getUserSFId()}&view=${newPath}`
        window.history.pushState({}, 'Property Search', '/PropertySearch?' + queryParam)

    }

    return (
        <>
            <div className="flex flex-col text-1">
                <div data-testid="test-sidebarmenu-find" className={`px-0 py-2 hover:underline cursor-pointer text-center ${selectedMenu === 'search' ? 'bg-gray-15 text-primary text-1' : 'bg-white text-base'}`}
                    onClick={() => modifyPath('search')}>
                    <div className="flex flex-col">
                        <div className="flex justify-center"><Search></Search></div>
                        <div className="flex justify-center">New<br />Property Search</div>
                    </div>
                </div>
                <div className="flex-grow border-t border-gray-200"></div>
                {/* bg-gray-15 text-primary theme-dark text-white*/}
                <div data-testid="test-sidebarmenu-list" className={`p-4 hover:underline cursor-pointer text-center ${selectedMenu === 'savedList' ? 'bg-gray-15 text-primary' : 'bg-white text-base'}`}
                    onClick={() => modifyPath('savedList')}>
                    <div className="flex flex-col">
                        <div className="flex justify-center"><List></List></div>
                        <div className="flex justify-center">Own/Shared<br />Lists</div>
                    </div>
                </div>
                <div className="flex-grow border-t border-gray-200"></div>
                <div data-testid="test-sidebarmenu-search" className={`p-4 hover:underline cursor-pointer text-center ${selectedMenu === 'savedSearch' ? 'bg-gray-15 text-primary' : 'bg-white text-base'}`}
                    onClick={() => modifyPath('savedSearch')}>
                    <div className="flex flex-col">
                        <div className="flex justify-center"><Bookmarks></Bookmarks></div>
                        <div className="flex justify-center">Saved<br />Searches</div>
                    </div>
                </div>
                <div className="flex-grow border-t border-gray-200"></div>
                {/* <div className={`p-4 cursor-pointer ${selectedMenu === 'saved' ? 'bg-gray-15 text-primary' : ''}`}
                    onClick={() => modifyPath('saved')}>
                    <div className="flex flex-col">
                        <div className="flex justify-center"><Bookmarks></Bookmarks></div>
                        <div className="flex justify-center">Saved<br />Search</div>
                    </div>
                </div> */}
            </div>
        </>
    )
}

